export const imageCodes = {
    aboutPhoto1: {
        code: "${merchantId}_tmpl_img_22",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fcontact.jpg?alt=media&token=2be4166c-2a85-4227-aa35-a3a8417622cc",
    },

    aboutPhoto2: {
        code: "${merchantId}_tmpl_img_14",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2F12.%20Pixiu%20.jpg?alt=media&token=34d114fb-0589-4578-be6e-8f35044fbebc",
    },
}


export const titleCodes = {
    aboutTitle: {
        code: "${merchantId}_tmpl_title_7",
        title: "29 Jewellery - 29ရတနာ"
    }
}

export const textCodes = {
    about1: {
        code: "${merchantId}_tmpl_text_22",
        text: "29 ရတနာ founder 29 Gems & Crystal ကို 2005 ခုနှစ်တွင် ကိုတူးနိင်ထွန်းမှ စတည်တည်ထောင်ခဲ့ပြီး မူလပထမ အစတွင် မိုးကုတ် တွင်းထွက် ကျောက်အရိုင်းတုံးများ (Gems & Crystal ) များ ကို နိင်ငံခြားသားများသို့ ရောင်းချခြင်းဖြင့် စတင်ခဲ့ပါသည်။"
    },

    about2: {
        code: "${merchantId}_tmpl_text_23",
        text: "2007 ခုနှစ်တွင် ဘန်ကောက်ရှိ AIGS သင်တန်းကျောင်းတွင် စိန်နှင့် ကျောက်မျက်ရတနာ ပညာရပ်များအား ထပ်မံ သင်ယူပြီးနောက် 2008 ခုနှစ် မှစတင်၍ စိန်ထည်များ အထည်ခတ်ကာ ထိုစဉ်အခါက စိန်ထည်ဝယ်သူတိုင်း ပြန်ရောင်းသည့်အခါသာမက အသစ်ဝတ်ချင်၍ အလိုက်ပေး ပြန်လဲသည့်အခါတွင်လည်း % အရှုံးခံရသည့် စနစ်ကို မကြိုက်သဖြင့် မြန်မာပြည်တွင် ပထမဆုံး စတင်တီထွင်သူအဖြစ် “စိန်ထည်များ ပြန်လဲလျှင် လုံးဝ မရှုံးစေရ “ ဟုဆိုကာ မွေးရပ်ဇာတိမြေ ရေစကြိုမှ စတင်ကာ မြန်မာပြည်အရပ်ရပ်သို့ တအိမ်ဝင်တအိမ်ထွက် (Door to Door ) စနစ်ဖြင့် လှည့်လည်ရောင်းချပေးခဲ့ပါသည်။"
    },
    
    about3: {
        code: "${merchantId}_tmpl_text_24",
        text: "2016 မေလ ၇ ရက်နေ့တွင် 29 ရတနာ ဟူ၍ ရန်ကုန်မြို့ ဗိုလ်ချုပ်စျေးတွင် စိန်ရွှေရတနာ ဆိုင် အသစ် ထပ်မံဖွင့်လှစ်ခဲ့ပြီး ရန်ကုန်မိတ်မရှိသော်လည်း ၈ နှစ်တာ နယ်မြို့များတွင် လှည့်လည် ကာ အာမခံချက် မှန်ကန်စွာ ရောင်းချခဲ့သောကျေးဇူးများကြောင့် အောင်မြင်မှုများ ရရှိခဲ့ပါသည် အချိန်တိုအတွင်း 29 ရတနာဟူ၍ မြန်မာပြည်တဝှမ်း လူကြိုက်များနေရသည့် အဓိက အကြောင်းရင်းခံမှာ ကိုဗစ်ကာလ အတွင်း ဆိုင်အားလုံးပိတ်ထားချိန်တွင် 29 ရတနာမှ ဝယ်ယူထားသည့် customer များ ပြန်ရောင်းလိုပါက အခက်အခဲမဖြစ်စေရန် ဖုန်းတစ်ချက်ဆက်ရုံမျှနှင့် ရန်ကုန်မြို့အတွင်း အိမ်တိုင်ရာရောက် လိုက်ဝယ်ပေးခြင်းဖြင့် မြန်မာ့ရတနာလောကတွင် အာမခံမှု အကောင်းဆုံးဆိုင်အဖြစ် အများပြည်သူများ ယုံကြည်လက်ခံခဲ့သောကြောင့်ဖြစ်ပါသည်။"
    },
    
    about4: {
        code: "${merchantId}_tmpl_text_25",
        text: "ထို့အတွက်လည်း 29 ရတနာအနေဖြင့် (၆) နှစ်တာအတွင်း ဆိုင်ခွဲပေါင်း (၃) ဆိုင် ဝန်ထမ်းအင်အား (၅၀၀) ကျော်ဖြင့် အရည်အသွေးပြည့်မှီကောင်းမွန်သော လက်ဝတ်ရတနာများကို ကိုယ်ပိုင် စက်ပန်းထိမ် ကြီးများဖြင့် ထုတ်လုပ်ကာ အာမခံချက်ကောင်းများစွာဖြင့် မြန်မာပြည်တဝှမ်းသို့ online စနစ်ဖြင့်ပါ ဝန်ဆောင်မှုအခမဲ့ဖြင့် လက်လီလက်ကား ဖြန့်ဖြူး ရောင်းချပေးလျှက်ရှိပါသည်။"
    },

    about5: {
        code: "${merchantId}_tmpl_text_26",
        text: "29 ရတနာဆိုင်၏ Core Value များ ဖြစ်သည့် -ဝန်ထမ်းများကို မိသားစုဝင်များသဖွယ် သဘောထားကာ အလုပ်တွင်ပျော်၍ လုပ်ငန်းခွင် တော်လာစေရန် ဖန်တီးပေးနိင်ရမည် ၊"
    },

    about6: {
        code: "${merchantId}_tmpl_text_27",
        text: "ဝယ်ယူသူများကို ပေးလိုက်ရသော တန်ဖိုးထက် ပို၍သာသော ဝန်ဆောင်မှုများဖြင့် ရာသက်ပန် စိတ်ကျေနပ်မှုကို ပေးနိင်ရမည် ၊"
    },

    about7: {
        code: "${merchantId}_tmpl_text_28",
        text: "ဆက်စပ် လုပ်က်ိုင်ရသော လုပ်ငန်းရှင် Suppliers များနှင့်ပတ်သတ်လျှင် အမည်ပျက် လုံးဝ လုံးဝ မရှိဘဲ နှစ်ရှည်လက်တွဲထားနိင်ရမည်။"
    },

    about8: {
        code: "${merchantId}_tmpl_text_29",
        text: "29 ရတနာ ဆိုင်သည် စိန်ရွှေရတနာ ဝယ်ယူ ဝတ်ဆင် စုဆောင်းလိုကြသော မိတ်ဆွေများအတွက် အရည်အသွေး ပြည်မှီ မှန်ကန်သော လက်ဝတ်ရတနာများ ထုတ်လုပ်ရောင်းချလျှက်ရှိသည် ။ ထို့အပြင် ပေးထားသော အာမခံချက်များ ထာဝရ တည်တံ့ပြီး ရာသက်ပန် စိတ်ချယုံကြည် စိတ်တိုင်းကျ ရသော ရတနာ ဆိုင်ကြီးအဖြစ် ရေရှည် ရပ်တည်နိင်ရန် အစဥ်အမြဲ ကြိုးစားအားထုတ် လျက်ရှိသည် ။ 29 ရတနာ မှ စိတ်ချယုံကြည်စွာ ဝယ်ယူအားပေးလျက်ရှိသော ဝယ်ယူတစ်ယောက်ချင်းစီတိုင်းကို အထူးပင် ကျေးဇူးတင်ရှိပါသည်။"
    },
}
